import { useSiteConfig } from './useSiteConfig';
import { init as fullStoryInit } from '@fullstory/browser';
import { useEffect } from 'react';

declare global {
  interface Window {
    _fs_initialized: boolean;
  }
}

export function useFullStory() {
  const siteConfig = useSiteConfig();
  useEffect(() => {
    const fullstoryInit = window?._fs_initialized;

    if (siteConfig.fullStoryEnabled && !fullstoryInit) {
      fullStoryInit({
        debug: false, //Enables FullStory debug messages
        host: 'fullstory.com', //Host name path of fullstory
        namespace: 'FS', //Sets the global identifier for FullStory when conflicts with FS arise
        orgId: 'P9XEH', //Sets your FullStory Org Id
        recordCrossDomainIFrames: true, //Capture Cross Domain IFrame conetnt
        recordOnlyThisIFrame: true, //Tells FullStory that the IFrame is the "root" of the recording and should be its own session
        script: 'edge.fullstory.com/s/fs.js', //script path
      });
    }
  }, [siteConfig]);
}
